import React, { useRef, useState } from 'react';
import {
  FlexRow,
  promiseModalDialog,
  toastFailure,
  toastSuccess,
  usePaginatedQueryV8,
} from 'motion-components';
import { Button, Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlClearUnsendMailsMutation, gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';
import { useApolloClient, useMutation } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { observer } from 'mobx-react-lite';
import { FaMailBulk } from 'react-icons/fa';
import { useTriggerMailService } from 'shared-pages/hooks/trigger-mail-service';

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const EMailsRepoGridPage = observer(
  ({ isGridInForm = false }: { isGridInForm?: boolean }) => {
    const { appStore, tableStore } = useRootStore();
    const { triggerMailService } = useTriggerMailService();
    const { handleGraphqlError } = useHandleError('EMailRepoGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    const { canView, canAddNew, canEdit, canDelete } = useUserLocationPermissions();

    const handleAddNew = () => {};
    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'composedDate DESC';
    const query = usePaginatedQueryV8(
      gqlGetQuery,
      buildWhereFromFilterValues,
      location.state?.order ?? initOrderBy,
      appStore,
      true,
      { isActive: true },
      true,
    );
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    const client = useApolloClient();

    const gridRef = useRef();

    async function sendMail(event) {
      triggerMailService();
      refetch();
      toastSuccess(t('Η διαδικασία αποστολής των μηνυμάτων ενεργοποιήθηκε με επιτυχία'));
    }

    const [clearUnsendMails] = useMutation(gqlClearUnsendMailsMutation);
    async function clearUnsend(event) {
      // μπορείς να βάλεις ένα μήνυμα επιβεβαίωσης απο τον χρήστη εδω
      const res = await promiseModalDialog({
        title: t('Επιβεβαίωση'),
        text: t('Είστε βέβαιοι ότι θέλετε να διαγράψετε τα μήνυμα που δεν έχουν αποσταλεί;'),
      });
      if (!res) {
        return;
      }

      const result = await clearUnsendMails();
      if (result.data.clearUnsendMails > 0) {
        toastSuccess(t('Διαγραφή Μή Απεσταλμένων Mail ολοκληρώθηκε με επιτυχία'));
        refetch();
      } else {
        toastFailure(t('Διαγραφή Μή Απεσταλμένων Mail απέτυχε'));
      }
    }

    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <Card className="shadow">
          {!isGridInForm && (
            <Card.Header>
              <FlexRow>
                <Card.Title className="m-0">{t('Αποθετήριο E-mail')}</Card.Title>
                <div>
                  <Button className="mx-2" variant="outline-danger" onClick={clearUnsend}>
                    {t('Ακύρωση Μή Απεσταλμένων Mail')}
                  </Button>
                  <Button onClick={sendMail}>
                    <FaMailBulk /> {t('Αποστολή mail')}
                  </Button>
                </div>
              </FlexRow>
            </Card.Header>
          )}

          <Card.Body className="nopadding">
            {/* Φίλτρα */}
            <Filters
              onChange={filtersChanged}
              initialValues={queryState?.filterValues ?? {}}
              //disable={tableStore.state !== TableDataState.browse}
              isGridInForm={isGridInForm}
            />

            {/* Grid */}
            <DataGrid
              ref={gridRef}
              loading={loading}
              data={data}
              hisoryRe
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              handleExport={() => {
                handleExport(client, queryState, t);
              }}
              initOrderBy={queryParams?.order ?? initOrderBy}
              onOrderChange={(orderBy) => {
                const newQueryParams = { ...queryParams, order: orderBy };
                setQueryParams(newQueryParams);
                history.replace({
                  pathname: location.pathname,
                  state: {
                    ...location.state,
                    order: orderBy,
                  },
                });
              }}
              selected={selected}
              setSelected={setSelected}
              refetch={refetch}
              isGridInForm={isGridInForm}
            />
          </Card.Body>
        </Card>
      );
    }
  },
);
